import { defineStore } from 'pinia';

export const useNetworkStore = defineStore('network', {
  state: () => ({
    online: navigator.onLine,
  }),

  actions: {
    setOnline(value: boolean) {
      this.online = value;
    },
  },
});
